import React, { useState } from 'react'
import { useEffectX } from 'use-effect-x'
import axios from 'axios'
import configData from '../config.json'
import { useTranslation } from 'react-i18next'
import ReactHtmlParser from 'react-html-parser'



const PageContact = () => {

  const { i18n } = useTranslation()
  const lang = i18n.language

  const [ pageData, setPageData ] = useState(null)

  useEffectX(
    ({changedItem: [pageDataObj]}) => {
      if (pageDataObj.isFirstRun) {
        axios.get(`${configData['REST_URL']}/wp/v2/pages?slug=contact`)
          .then(data => setPageData(data.data[0])) 
      }
    }, [pageData]
  )
  
  const renderContent = () => {
    const content = ReactHtmlParser(pageData.content.rendered)
    const translatedContent = content.filter(el => {
      return el.props.id === lang
    })[0]
    return translatedContent
  }

  return (
    <div className="page page-contact">
    <div className="contact-image"></div>
      <div className="page-content">
        <div className="contact-data">
          {pageData && renderContent()}
        </div>
        <div className="contact-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9273.91238951661!2d18.278533!3d54.472146!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fda2b3432fecbf%3A0x81c6a073bc7005cd!2sAsnyka%202%2C%2084-217%20Kamie%C5%84%2C%20Polska!5e0!3m2!1spl!2sus!4v1620766306093!5m2!1spl!2sus" id="googleMap" loading="lazy" title="map"></iframe>
        </div>
        
      </div>
    </div>
  )
}

export default PageContact